
import Button from '../base/Button';

export default function FinalOffer() {
  const handleBuyNow = () => {
    window.open('https://entrega.logzz.com.br/pay/mem6qvd4r/1-kit-com-6-facas-promocao', '_blank');
  };

  const scrollToFAQ = () => {
    const element = document.querySelector('section');
    const faqElements = document.querySelectorAll('section');
    let faqSection = null;
    
    faqElements.forEach(section => {
      const h2 = section.querySelector('h2');
      if (h2 && h2.textContent?.includes('Perguntas Frequentes')) {
        faqSection = section;
      }
    });
    
    faqSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <section id="oferta" className="py-16 bg-black">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h2 className="text-3xl lg:text-5xl font-bold mb-6">
              Última Chance!
            </h2>
            
            <p className="text-xl lg:text-2xl mb-8 opacity-90">
              Não perca esta oferta especial por tempo limitado
            </p>
            
            <div className="bg-white rounded-2xl p-8 text-gray-800 mb-8">
              <div className="grid md:grid-cols-2 gap-8 items-center">
                <div>
                  <img 
                    src="https://static.readdy.ai/image/32da3dbc6c077a42865d0d012e77efdf/a10348d8090ca186fba9170a9ca4f538.jfif"
                    alt="Kit Completo de Facas"
                    className="w-full h-auto rounded-lg object-top"
                  />
                </div>
                
                <div className="text-left">
                  <h3 className="text-2xl font-bold mb-4">Kit Completo - 6 Peças</h3>
                  
                  <div className="space-y-2 mb-6">
                    <div className="flex items-center gap-2">
                      <i className="ri-check-line text-green-500"></i>
                      <span>Entrega em até 24 horas</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <i className="ri-check-line text-green-500"></i>
                      <span>Você só paga na entrega</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <i className="ri-check-line text-green-500"></i>
                      <span>Garantia de 7 dias</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <i className="ri-check-line text-green-500"></i>
                      <span>Frete Grátis</span>
                    </div>
                  </div>
                  
                  <div className="space-y-2">
                    <div className="flex items-center gap-3">
                      <span className="text-lg text-gray-500">De</span>
                      <span className="text-xl text-gray-400 line-through">R$ 219,99</span>
                      <span className="bg-red-100 text-red-600 px-2 py-1 rounded text-sm font-semibold">
                        40% OFF
                      </span>
                    </div>
                    <div className="text-4xl font-bold text-red-600">
                      R$ 129,90
                    </div>
                    <div className="text-sm text-gray-5">
                      Pagamento na entrega: Dinheiro, PIX, Cartão
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="space-y-4">
              <Button 
                onClick={handleBuyNow}
                size="lg" 
                className="w-full md:w-auto text-xl py-5 px-12 flex-col gap-1 bg-[#13d624] hover:bg-[#11c220] text-white shadow-lg hover:shadow-xl"
              >
                <div className="flex items-center">
                  <i className="ri-shopping-cart-line mr-2"></i>
                  PEDIR AGORA - R$ 129,90
                </div>
                <div className="text-sm font-normal opacity-90">
                  PAGAR SÓ NA ENTREGA
                </div>
              </Button>
              
              <div>
                <button 
                  onClick={scrollToFAQ}
                  className="text-white/80 hover:text-white underline cursor-pointer"
                >
                  Ver Perguntas Frequentes
                </button>
              </div>
            </div>
            
            <div className="mt-8 text-sm opacity-75">
              <p>🔒 Compra 100% segura - Você só paga na entrega</p>
            </div>
          </div>
        </div>
      </section>

      {/* Seção WhatsApp */}
      <section className="py-12 bg-gray-900">
        <div className="container mx-auto px-4 text-center">
          <p className="text-white text-xl mb-6">
            Se ficou alguma dúvida, chame nossa equipe no WhatsApp
          </p>
          <a
            href="https://wa.me/5584999495676?text=Olá!%20Vim%20do%20site%20e%20tenho%20interesse%20no%20Kit%20de%20Facas%20Profissional%206%20Peças."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-6 text-white px-8 py-4 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap text-lg"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Falar no WhatsApp
          </a>
        </div>
      </section>
    </>
  );
}
